<template>
  <div class="kyuukei">
    <h3>休憩未取得申請</h3>
    <div class="col-item">
      <b class="title"><p>休憩未取得<br>勤務日</p></b>
      <p>{{ kyuukeiJikangai?.kyuukei_jikangai_date }}</p>
    </div>
    <div class="col-item">
      <b class="title">就業場所</b>
      <p>{{ form.syuugyou_basyo_name }}</p>
    </div>
    <div class="col-item">
      <b class="title">就業時間</b>
      <p v-if="workTime.length > 0">{{ workTime[0].disp_work_time }}</p>
      <p v-else>無し</p>
    </div>
    <div class="col-item">
      <b class="title">作業時間</b>
      <p>{{ kyuukeiJikangai?.kyuukei_jikangai_times }}</p>
    </div>
    <div class="col-item">
      <b class="title"><p>業務内容<br>（詳細に）</p></b>
      <p class="pre">{{ kyuukeiJikangai?.gyoumu_notes ?? '無し' }}</p>
    </div>
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { useForm } from '@/composable/form/form';
import dayjs from 'dayjs'
import { KoyouKeiyakuTimeForDetail, Shinsei } from '@/types/Shinsei';


export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    workTime: {
      type: Object as () => KoyouKeiyakuTimeForDetail[],
      default: null
    },
  },
  setup(props) {

    const kyuukeiJikangai = props.form.kyuukei_jikangai;
    const workTime = props.workTime;

    // エラー取得
    const { getError } = useForm();

    const dateTimeFormatter = (val: string | null | undefined) => {
      if(!val){
        return
      }
      const date = dayjs(val).format('YYYY/MM/DD HH:mm')
      return date
    }

    return {
      kyuukeiJikangai,
      getError,
      dateTimeFormatter,
      workTime,
    }
  },
  components: {

  }
})

</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>